import { CREATE_DROPER, EDIT_DROPER, ENABLE_DISABLE_DROPER, LIST_DROPER, RESET_PASSWORD_DROPER, UPLOAD_DROPER_IMAGE, VIEW_DROPER } from "./types";


export const createDroperAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_DROPER,
        data,
        onSuccess,
        onError,
    };
};

export const editDroperAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_DROPER,
        data,
        onSuccess,
        onError,
    };
};

export const listDroperAction = (data, onSuccess, onError) => {
    return {
        type: LIST_DROPER,
        data,
        onSuccess,
        onError,
    };
};

export const viewDroperAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_DROPER,
        data,
        onSuccess,
        onError,
    };
};

export const enableDisableDroperAction = (data, onSuccess, onError) => {
    return {
        type: ENABLE_DISABLE_DROPER,
        data,
        onSuccess,
        onError,
    };
};

export const resetPasswordDroperAction = (data, onSuccess, onError) => {
    return {
        type: RESET_PASSWORD_DROPER,
        data,
        onSuccess,
        onError,
    };
};


export const uploadDroperImageAction = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_DROPER_IMAGE,
        file,
        onSuccess,
        onError,
    };
};